<template>
  <a-dropdown>
    <a style="line-height: 40px" @click.prevent>
      <img
        :src="localeActive?.img"
        alt="flag"
        style="height: 1.3rem; border-radius: 0px; margin-right: 5px"
      />
      <span style="color: #fff">{{ localeActive?.label }}</span>
    </a>
    <template #overlay>
      <a-menu @click="handleChange">
        <a-menu-item v-for="item in locales" :key="item.value">
          <a href="javascript:;">
            <img
              :src="item.img"
              alt="flag"
              style="height: 1.3rem; border-radius: 0px; margin-right: 5px"
            />
            <span>{{ item.label }}</span>
          </a>
        </a-menu-item>
      </a-menu>
    </template>
  </a-dropdown>
</template>

<script lang="ts" setup>
import { onMounted, ref, computed, watch } from "vue";
import { useI18n } from "vue-i18n";

import store from "@/store";

const { locale } = useI18n();

const locales = ref([
  {
    value: "en-US",
    label: "English",
    img: "./flags/us.svg",
  },
  {
    value: "zh-CN",
    label: "中文",
    img: "./flags/cn.svg",
  },
  {
    value: "vi-VN",
    label: "Tiếng Việt",
    img: "./flags/vn.svg",
  },
]);

const localeActive = computed(() => {
  return locales.value.find((item) => item.value === locale.value);
});

const handleChange = (item: any) => {
  store.commit("language/setCurrentLanguage", item.key);
  location.reload();
};

const languageList = computed(() => store.state.language.LANGUAGE_LIST);

const getI18nLanguage = async () => {
  // console.log(languageList.value, "languageList");
  if (languageList.value) {
    const localelist = Object.keys(languageList.value).map((key) => {
      return {
        value: key,
        label: languageList.value?.[key] ? languageList.value?.[key] : "",
        img: `${import.meta.env.VITE_PUBLIC_BASE}/flags/${key
          .split("-")[1]
          ?.toLowerCase()}.svg`,
      };
    });

    if (localelist.length > 0) {
      locales.value = localelist;
    }
  }
};

watch(languageList, getI18nLanguage);

onMounted(async () => await store.dispatch("language/getLanguageList"));
</script>
